import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const SuperscriptIcon = (props)=>{
    const $ = c(7);
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M14.4603 6.97143H11.8531C11.4044 6.97143 11.2094 6.7133 11.2094 6.35796C11.2094 6.09648 11.3264 5.89535 11.5865 5.67074L12.8771 4.53097C13.4038 4.065 13.5533 3.85381 13.5533 3.56551C13.5533 3.26046 13.3258 3.04926 12.9909 3.04926C12.7438 3.04926 12.5748 3.16659 12.3992 3.42807C12.2172 3.70296 12.0514 3.80353 11.7881 3.80353C11.437 3.80353 11.2224 3.59233 11.2224 3.2504C11.2224 3.13978 11.2419 3.03585 11.2842 2.93529C11.5312 2.35869 12.1912 2 13.0104 2C14.1515 2 14.8797 2.59335 14.8797 3.47165C14.8797 4.12199 14.5546 4.46057 13.8264 5.11091L12.9714 5.87188V5.8987H14.4603C14.8049 5.8987 15 6.10989 15 6.43506C15 6.75353 14.8049 6.97143 14.4603 6.97143Z"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M2.64932 2C2.88623 2 3.10428 2.13024 3.21804 2.3397L5.7449 6.99219H5.82707L8.35227 2.34275C8.46706 2.13141 8.68706 2 8.9261 2C9.4249 2 9.7402 2.54011 9.49796 2.97961L6.73085 8L9.49668 13.0181C9.73949 13.4586 9.42345 14 8.92347 14C8.68575 14 8.46665 13.8703 8.35083 13.6611L5.82707 9.10156H5.7449L3.21947 13.6641C3.10468 13.8715 2.88753 14 2.65194 14C2.15339 14 1.8405 13.4575 2.08717 13.0208L4.92328 8L2.08588 2.97687C1.83978 2.5412 2.15194 2 2.64932 2Z"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M14.4603 6.97143H11.8531C11.4044 6.97143 11.2094 6.7133 11.2094 6.35796C11.2094 6.09648 11.3264 5.89535 11.5865 5.67074L12.8771 4.53097C13.4038 4.065 13.5533 3.85381 13.5533 3.56551C13.5533 3.26046 13.3258 3.04926 12.9909 3.04926C12.7438 3.04926 12.5748 3.16659 12.3992 3.42807C12.2172 3.70296 12.0514 3.80353 11.7881 3.80353C11.437 3.80353 11.2224 3.59233 11.2224 3.2504C11.2224 3.13978 11.2419 3.03585 11.2842 2.93529C11.5312 2.35869 12.1912 2 13.0104 2C14.1515 2 14.8797 2.59335 14.8797 3.47165C14.8797 4.12199 14.5546 4.46057 13.8264 5.11091L12.9714 5.87188V5.8987H14.4603C14.8049 5.8987 15 6.10989 15 6.43506C15 6.75353 14.8049 6.97143 14.4603 6.97143Z",
            strokeWidth: "0.3"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M2.64932 2C2.88623 2 3.10428 2.13024 3.21804 2.3397L5.7449 6.99219H5.82707L8.35227 2.34275C8.46706 2.13141 8.68706 2 8.9261 2C9.4249 2 9.7402 2.54011 9.49796 2.97961L6.73085 8L9.49668 13.0181C9.73949 13.4586 9.42345 14 8.92347 14C8.68575 14 8.46665 13.8703 8.35083 13.6611L5.82707 9.10156H5.7449L3.21947 13.6641C3.10468 13.8715 2.88753 14 2.65194 14C2.15339 14 1.8405 13.4575 2.08717 13.0208L4.92328 8L2.08588 2.97687C1.83978 2.5412 2.15194 2 2.64932 2Z",
            strokeWidth: "0.3"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] !== props.height || $[5] !== props.width) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3
            ]
        });
        $[4] = props.height;
        $[5] = props.width;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
export { SuperscriptIcon };
